import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
const appRoutes : Routes = [
	 { path: '', component : DashboardComponent}
]

@NgModule({
  imports: [
    RouterModule.forChild(appRoutes)
  ],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/dashboard/dashboard-routing.module.ts